export default function($) {

  var IwProductGlobalAddToCart = function(element, wrapper){
    // we do nothing is the selector is not found
    if (element.length) {
      this.element = element;
      this.wrapper = wrapper;
      this.productVariationElements = $.map(
        this.wrapper.find('.js-iw-product-variation'),
        function(product_variation) {
          return new Iw_product_variation($(product_variation))
        }
      )

      this.actionClass = "js-iw-global-add-to-cart-link";

      this.renderBaseFeatureComponent();

      var self = this;
      this.element.find("."+this.actionClass).click(function(event) {
        event.preventDefault();
        self.addAllVariationsToCart();
      })
    }
  }

  IwProductGlobalAddToCart.prototype = {
    renderBaseFeatureComponent: function() {
      // This is because we do not want this to work if no javascript enabled so we can't render the input in backend.
      var linkTag = "<a href=\"#0\" class=\""+this.actionClass+" iw_add_all_to_cart\">Ajouter ces quantités au panier</a>";
      this.element.append(linkTag);
    },
    addAllVariationsToCart: function() {
      var valid_variations = $.grep(
        this.productVariationElements,
        function(variation, index) {
          var qty = parseInt(Number( variation.quantity() ));
          if (isNaN(qty) || qty <= 0) {
            return false;
          }

          if (variation.validate()) {
            return true;
          }

          return false
        }
      )

      if (valid_variations.length == 0) {
        return true;
      }

      var variation_datas = $.map(
        valid_variations,
        function(valid_variation) {
          return {
            "product_id" : valid_variation.product_id,
            "variation_id" : valid_variation.variation_id,
            "quantity" : valid_variation.quantity(),
            "attributes" : valid_variation.attributes,
          }
        }
      )

      $.ajax({
        url: client_configuration.ajax_url,
        data: {
          "action" : "woocommerce_add_variations_to_cart",
          "variations" : variation_datas,
        },
        type: "POST",
        success: function() {
          // We force refresh woocommerce mini-cart fragments using
          // WooCommerce native event 'wc_fragment_refresh'
          $( document.body ).trigger( 'wc_fragment_refresh' );

          $.each(
            valid_variations,
            function(index, value) {
              value.do_after_add_to_cart_action()
              value.render("success")
            }
          )
        }
      })
    },
  }

  $(document).ready(function () {
    $('.js-iw-product-wrapper').each(function () {
      var globalProductAddTo = $(this).find('.js-iw-global-add-to-cart');
      var iwms = new IwProductGlobalAddToCart(globalProductAddTo, $(this));
    })
  })

}
